import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { appApi } from "@/lib/api";

const POLL_MS = 60000;
const SEEN_KEY = "sz_status_map";

const loadSeen = () => {
  try {
    return JSON.parse(localStorage.getItem(SEEN_KEY) || "{}");
  } catch {
    return {};
  }
};

export const NdrWatcher = () => {
  const firstRun = useRef(true);

  const check = async () => {
    try {
      const d = await appApi.get("orders");
      const orders = d.orders || [];
      const seen = loadSeen();
      const next = { ...seen };
      const newNdr = [];
      for (const o of orders) {
        const status = String(o.status || "").toLowerCase();
        const prev = seen[o.id];
        if (status === "ndr" && prev !== "ndr") newNdr.push(o);
        next[o.id] = status;
      }
      localStorage.setItem(SEEN_KEY, JSON.stringify(next));
      if (firstRun.current) {
        firstRun.current = false;
        return;
      }
      for (const o of newNdr) {
        toast.error(`NDR: ${o.awb} — delivery failed. Act now before auto-RTO.`, {
          duration: 15000,
          action: {
            label: "Review",
            onClick: () => (window.location.href = "/dashboard/ndr"),
          },
        });
      }
    } catch { /* keep polling silently */ }
  };

  useEffect(() => {
    check();
    const t = setInterval(check, POLL_MS);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
